import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';
import { ApiHomeService } from '@core/api/services/home/api-home.service';
import { homeActions } from '@store/actions/home.actions';
import { HomeMyServicesMapper } from '@core/domain/mappers/home/home-my-services.mapper';
import { HomeMyInvoicesMapper } from '@core/domain/mappers/home/home-my-invoices.mapper';
import { StoreState } from '@store/store.state';
import { Store } from '@ngrx/store';
import { masterSelectors } from '@store/selectors/master.selectors';

@Injectable()
export class HomeEffects {
  /**
   * Fetch data for my services (home)
   */
  fetchMyServices$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.fetchMyServices),
      switchMap(() => this.apiHomeService.fetchMyServices(homeActions.fetchMyServices.type)),
      map((api) => api.data),
      map((api) => HomeMyServicesMapper.modelFromApi(api)),
      map((services) => homeActions.setMyServices({ services }))
    )
  );

  /**
   * Fetch data for my invoices (home)
   */
  fetchMyInvoices$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.fetchMyInvoices),
      switchMap(() => this.apiHomeService.fetchMyInvoices(homeActions.fetchMyInvoices.type)),
      map((api) => api.data),
      withLatestFrom(this._store.select(masterSelectors.ggccSocieties)),
      map(([api, ggccSocieties]) => HomeMyInvoicesMapper.modelFromApi(api, ggccSocieties)),
      map((invoices) => homeActions.setMyInvoices({ invoices }))
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly apiHomeService: ApiHomeService,
    private readonly _store: Store<StoreState>
  ) {}
}
